import { HttpInterceptorFn } from "@angular/common/http";

export const cleanupInterceptor: HttpInterceptorFn = (req, next) => {
  let newParams = req.params;

  req.params.keys().forEach((key) => {
    const values = req.params.getAll(key);
    if (values) {
      const cleanValues = values.filter((val) => val !== "null" && val !== "undefined" && val !== null && val !== undefined && val !== "");

      if (cleanValues.length === 0) {
        newParams = newParams.delete(key);
      }
    }
  });

  let newBody = req.body;

  if (req.body && typeof req.body === "object" && !Array.isArray(req.body) && !(req.body instanceof Blob) && !(req.body instanceof FormData)) {
    newBody = Object.fromEntries(
      Object.entries(req.body).filter(([_, v]) => v !== null && v !== undefined && v !== ""),
    );
  }

  const newReq = req.clone({
    params: newParams,
    body: newBody,
  });

  return next(newReq);
};
